/**
 * Scheduler Domain Types (Premium Feature)
 * Defines types for recurring payment schedulers
 */
/**
 * Available columns for scheduler export with their display labels
 */
export const SCHEDULER_EXPORT_COLUMNS = [
    { key: 'startDate', labelKey: 'schedulerExport.columns.startDate' },
    { key: 'endDate', labelKey: 'schedulerExport.columns.endDate' },
    { key: 'nextOccurrence', labelKey: 'schedulerExport.columns.nextOccurrence' },
    { key: 'periodicity', labelKey: 'schedulerExport.columns.periodicity' },
    { key: 'direction', labelKey: 'schedulerExport.columns.direction' },
    { key: 'amount', labelKey: 'schedulerExport.columns.amount' },
    { key: 'counterpartyName', labelKey: 'schedulerExport.columns.counterparty' },
    { key: 'categoryNames', labelKey: 'schedulerExport.columns.categories' },
    { key: 'paymentMethodName', labelKey: 'schedulerExport.columns.paymentMethod' },
    { key: 'paymentDetails', labelKey: 'schedulerExport.columns.paymentDetails' },
    { key: 'reference', labelKey: 'schedulerExport.columns.reference' },
    { key: 'comment', labelKey: 'schedulerExport.columns.comment' },
    { key: 'status', labelKey: 'schedulerExport.columns.status' },
    { key: 'autoPoint', labelKey: 'schedulerExport.columns.autoPoint' },
];
//# sourceMappingURL=scheduler.js.map